import React from 'react';
import { useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { PersonalLoanPrequalModuleView } from './PersonalLoanPrequalModuleView';
import { useHistory } from 'react-router-dom';
import { PERSONAL_LOAN_PREQUAL } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel } from 'hook/helper.hook';
import { PERSONAL_LOAN_HIGH_CC_DEBT } from 'externals/_tracking/optimizely/optimizely.exp.constants';
import { useVariationForExperiment } from 'externals/_tracking/optimizely/optimizely.hook';

const PersonalLoanPrequalModuleController = ({
  moduleList,
  modulePosition,
  ...props
}) => {
  const personalLoanHighCcDebtExp = useVariationForExperiment(
    PERSONAL_LOAN_HIGH_CC_DEBT,
  );

  const isPersonalLoanHighCcDebtExpVar1 =
    personalLoanHighCcDebtExp.loading === false &&
    personalLoanHighCcDebtExp.variation === 'VAR1';
  const isPersonalLoanHighCcDebtExpVar2 =
    personalLoanHighCcDebtExp.loading === false &&
    personalLoanHighCcDebtExp.variation === 'VAR2';

  const moduleData = moduleList.modules[modulePosition - 1];
  const isActionsModule = moduleData && moduleData.isActionsModule;
  const history = useHistory();

  const atr = getViewModuleTrackingAttributes({
    pagePosition: PERSONAL_LOAN_PREQUAL,
    modulePosition: modulePosition,
    vertical: 'Personal Loan',
  });

  useViewModule(atr, !isActionsModule);

  const seenPixel = useSeenModulePixel(atr);
  return (
    <PersonalLoanPrequalModuleView
      history={history}
      isActionsModule={isActionsModule}
      seenPixel={seenPixel}
      isPersonalLoanHighCcDebtExpVar1={isPersonalLoanHighCcDebtExpVar1}
      isPersonalLoanHighCcDebtExpVar2={isPersonalLoanHighCcDebtExpVar2}
      modulePosition={modulePosition}
      {...props}
    />
  );
};

export { PersonalLoanPrequalModuleController };
